import { VStack } from "@gluestack-ui/themed";
import { NewTransactionConfirmController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { Button } from "@repo/core/components/core/Button";
import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import { AlertModalVariant } from "@repo/core/components/layout/ModalTemplate/AlertModal/types";
import { formatDateTimeString } from "@repo/core/utils/date.utils";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { ConfirmCardPassword } from "@repo/core/components/layout/ConfirmPassword";
import Spinner from "@repo/core/components/core/Spinner";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { TransactionFlowType } from "@repo/core/screens/NewTransaction/types";

const NewTransactionConfirm = () => {
  const {
    isMobile,
    handleConfirmCardPassword,
    alertModalRef,
    alertOptions,
    isValidatingPassword,
    handleBack,
    title,
    transactionValue,
    selectedInstallment,
    bonusValue,
    flowType,
    selectedStore
  } = NewTransactionConfirmController();
  return (
    <Scaffolds.Root
      title={title}
      statusBarVariant={StatusBarVariantEnum.LIGHT}
      minHeight="$100vh"
      onBackPress={handleBack}
    >
      <Scaffolds.Form
        showHeader={false}
        footerContent={
          <VStack
            w="$full"
            gap="$4"
            pb={isMobile ? "$4" : "$12"}
            px="$4"
            pt="$4"
            justifyContent="flex-end"
          >
            <Button
              text="Cancelar"
              action="negative"
              variant="outline"
              onPress={handleBack}
            />
          </VStack>
        }
      >
        <VStack gap="$1" alignItems="center" pt="$24">
          {selectedInstallment && (
            <Text color="$textLight900" fontWeight={700}>
              {selectedInstallment.intPrazo}x de R${" "}
              {numberToBrl(selectedInstallment.dblValorPrestacao)}
            </Text>
          )}
          <Text
            fontWeight={selectedInstallment ? 500 : 700}
            fontSize={selectedInstallment ? "$sm" : "$md"}
            color="$textLight900"
          >
            Valor total:{" "}
            {flowType === TransactionFlowType.BONUS_RETRIEVAL
              ? numberToBrl(bonusValue || 0)
              : numberToBrl(transactionValue)}
          </Text>
          <ConfirmCardPassword
            handleConfirmCardPassword={handleConfirmCardPassword}
            pt="$10"
          />

          {isValidatingPassword && <Spinner size={32} my="$2" />}
        </VStack>
      </Scaffolds.Form>
      <AlertModal
        ref={alertModalRef}
        title="Transação realizada"
        variant={AlertModalVariant.success}
        options={alertOptions}
      >
        <VStack alignItems="center" justifyContent="center" gap="$2" pb="$6">
          <Text fontWeight={600} textAlign="center">
            {selectedStore?.descrLoja}
          </Text>
          <Text fontWeight={600} textAlign="center">
            {numberToBrl(
              flowType === TransactionFlowType.BONUS_RETRIEVAL
                ? bonusValue || 0
                : transactionValue
            )}
          </Text>
          <Text fontSize="$sm" textAlign="center">
            {formatDateTimeString(new Date())}
          </Text>
        </VStack>
      </AlertModal>
    </Scaffolds.Root>
  );
};
export default NewTransactionConfirm;
